'use strict';

var processInclude = window._hbcProcessInclude;
// To hide 'Other ways to Pay' label when there is no option on PDP
function toggleOtherWaysToPay(){
     var pbPreQualifyDiv = document.getElementById('paybright_prequalify_div')? true  : false;
    var neoPDPDiv = document.getElementById('neopdpshow') ? true  : false;
    if(!pbPreQualifyDiv && !neoPDPDiv){
        $('#other-payments-label').addClass('d-none');
    }else{
        if((pbPreQualifyDiv && $('#paybright_prequalify_div').hasClass('d-none')) ||  !pbPreQualifyDiv){
            if((neoPDPDiv && $('#neopdpshow').hasClass('d-none')) || !neoPDPDiv){
                $('#other-payments-label').addClass('d-none');
            }
        }
    }
}

function togglePDPMobile(){// to toggle PDP product name section for mobile view, on the top of image container
    var isMobile = false; //initiate as false
    // device detection
    isMobile = window.matchMedia("only screen and (max-width: 543px)").matches;
    if(isMobile){
        $(".mobile-toggle-main-div").appendTo(".mobile-toggle-div");
    }
    else{
        $(".mobile-toggle-main-div").prependTo(".pdp-right-section");
    }
    $(".primary-images-container").css("visibility", "visible");
}

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/loadMiraklOffers'));
    processInclude(require('./product/miraklQuantityForm'));
    processInclude(require('./product/addOffer'));
    toggleOtherWaysToPay();
    togglePDPMobile();
    window.addEventListener('resize', togglePDPMobile);
});

 
